class Segment {

  static identify(user) {
    if (this.checkIfLoaded()) {
      window.analytics.identify(user._id, {
        name: user.info.name,
        email: user.info.email,
        phone: user.info.phone
      });
    }
  }

  static page() {
    if (this.checkIfLoaded()) {
      window.analytics.page();
    }
  }

  static reset() {
    if (this.checkIfLoaded()) {
      window.analytics.reset();
    }
  }

  static track(event, properties = {}) {
    if (this.checkIfLoaded()) {
      window.analytics.track(event, properties);
    }
  }
}

Segment.checkIfLoaded = () => !!window.analytics;

export default Segment;